import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  console.log('[validateAuthenticateRoutePermission] === ENTRY ===', {
    to: to.name,
    isLoggedIn,
    hasUser: !!user,
    userAccounts: user?.accounts?.length,
    accountId: user?.account_id,
  });

  // 登录页面白名单：直接放行，不进行权限检查
  if (to.name === 'login' || to.name === 'phone_auth') {
    console.log('[validateAuthenticateRoutePermission] Login page, allowing access');
    return next();
  }

  if (!isLoggedIn) {
    console.log(
      '[validateAuthenticateRoutePermission] Not logged in, redirecting to login'
    );
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    console.log(
      '[validateAuthenticateRoutePermission] No accounts, redirecting to no-accounts'
    );
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    console.log(
      '[validateAuthenticateRoutePermission] No route name, redirecting to dashboard'
    );
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  console.log(
    '[validateAuthenticateRoutePermission] About to call validateLoggedInRoutes'
  );
  const nextRoute = validateLoggedInRoutes(
    to,
    store.getters.getCurrentUser,
    store
  );
  console.log(
    '[validateAuthenticateRoutePermission] Route validation result:',
    {
      to: to.name,
      nextRoute,
      hasStore: !!store,
    }
  );
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
